/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_DescriptionInputs */

const zh_analytics_description = /** @type {(inputs: Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看您的 AI 使用情况和费用统计。`)
};

const en_analytics_description = /** @type {(inputs: Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View your AI usage and cost statistics.`)
};

const es_analytics_description = /** @type {(inputs: Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta tus estadísticas de uso y costos de IA.`)
};

/**
* | output |
* | --- |
* | "View your AI usage and cost statistics." |
*
* @param {Analytics_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const analytics_description = /** @type {((inputs?: Analytics_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_description(inputs)
	if (locale === "en") return en_analytics_description(inputs)
	return es_analytics_description(inputs)
});